import React, { useState, useEffect, useRef } from 'react';
import {
    YMaps,
    Map,
    Placemark,
    GeolocationControl,
} from '@pbe/react-yandex-maps';
import axios from 'axios';

import './MapPage.css';

import placemarkIcon from './../../images/placemark.png';
import userLocation from './../../images/location-user.svg';
import userAvatar from './../../images/unkonowprofile.jpg';
import { el } from 'date-fns/locale';

const MapPage = ({
    source,
    setCurrentPage,
    mapCenter,
    userlatitude,
    userlongitude,
    typeOfDate,
    eventSubCategory,
    setNewEventAddress,
    setNewEventCoords,
    setEventInfo,
    eventSubCategoryId,
    loadingEvents,
    events,
    setNewRecommendAddress,
    setNewRecommendCoords,
}) => {
    const [center, setCenter] = useState(mapCenter);

    const apiKey = '02484e23-0240-4235-a722-75b36529dc87';
    const userLang = localStorage.getItem('userLanguage');

    const [userLangMap, setUserLangMap] = useState(null);

    useEffect(() => {
        if (userLang === 'en-EN') {
            setUserLangMap('en_US');
        } else {
            setUserLangMap('ru_RU');
        }
    }, [userLang]);

    // получение мероприятий
    useEffect(() => {
        if (source === 'MainPage') {
            loadingEvents();
            console.log('userlatitude: ', userlatitude);
            console.log('userlongitude: ', userlongitude);
        }
    }, [typeOfDate, eventSubCategory]);

    // получение адреса и координат при клике на карту
    const handleMapClick = async (event) => {
        if (source === 'NewEvents') {
            const coords = event.get('coords');

            setNewEventCoords([coords[0], coords[1]]); // координаты места

            try {
                const geocodeResponse = await axios.get(
                    'https://geocode-maps.yandex.ru/1.x/',
                    {
                        params: {
                            apikey: apiKey,
                            format: 'json',
                            lang: userLangMap,
                            geocode: `${coords[1]},${coords[0]}`,
                        },
                    }
                );

                const geoObject =
                    geocodeResponse.data.response.GeoObjectCollection
                        .featureMember[0]?.GeoObject;

                if (geoObject) {
                    const components =
                        geoObject.metaDataProperty.GeocoderMetaData.Address
                            .Components;

                    const city = components.find(
                        (component) => component.kind === 'locality'
                    )?.name;
                    const street = components.find(
                        (component) => component.kind === 'street'
                    )?.name;
                    const house = components.find(
                        (component) => component.kind === 'house'
                    )?.name;

                    const formattedAddress = [city, street, house]
                        .filter((part) => part)
                        .join(', ');

                    setNewEventAddress(formattedAddress); // адрес места
                    setCurrentPage('AddEventPage');
                } else {
                    console.error(
                        'Не удалось найти адрес для указанных координат.'
                    );
                }
            } catch (error) {
                console.error('Ошибка обратного геокодирования:', error);
            }
        }

        if (source === 'NewRecommend') {
            const coords = event.get('coords');

            setNewRecommendCoords([coords[0], coords[1]]); // координаты места

            try {
                const geocodeResponse = await axios.get(
                    'https://geocode-maps.yandex.ru/1.x/',
                    {
                        params: {
                            apikey: apiKey,
                            format: 'json',
                            lang: userLangMap,
                            geocode: `${coords[1]},${coords[0]}`,
                        },
                    }
                );

                const geoObject =
                    geocodeResponse.data.response.GeoObjectCollection
                        .featureMember[0]?.GeoObject;

                if (geoObject) {
                    const components =
                        geoObject.metaDataProperty.GeocoderMetaData.Address
                            .Components;

                    const city = components.find(
                        (component) => component.kind === 'locality'
                    )?.name;
                    const street = components.find(
                        (component) => component.kind === 'street'
                    )?.name;
                    const house = components.find(
                        (component) => component.kind === 'house'
                    )?.name;

                    const formattedAddress = [city, street, house]
                        .filter((part) => part)
                        .join(', ');

                    setNewRecommendAddress(formattedAddress); // адрес места
                    setCurrentPage('AddRecommendPage');
                } else {
                    console.error(
                        'Не удалось найти адрес для указанных координат.'
                    );
                }
            } catch (error) {
                console.error('Ошибка обратного геокодирования:', error);
            }
        }
    };

    // клик по метке на карте
    const handlePlacemarkClick = async (eventId) => {
        if (source === 'MainPage') {
            try {
                const response = await axios.get(
                    'https://mepointserver.ru/event/detail',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                'authToken'
                            )}`,
                            'Accept-Language': userLang,
                        },
                        params: {
                            eventId: eventId,
                        },
                    }
                );
                if (response.data.success) {
                    setEventInfo(response.data.result);
                    console.log(response.data.result);
                    setCurrentPage('EventJoinPage');
                }
            } catch (error) {
                console.error(
                    'Ошибка при получении данных о мероприятии ',
                    error
                );
            }
        }
    };

    return (
        <div className='map__container'>
            <div className='yandex_map'>
                <YMaps query={{ apikey: apiKey }}>
                    <Map
                        key={mapCenter.join(',')}
                        state={{ center: mapCenter, zoom: 15 }}
                        width='100%'
                        height='100%'
                        onClick={handleMapClick}
                    >
                        {events.length > 0 &&
                            events.map((event) => (
                                <Placemark
                                    key={event.id}
                                    geometry={[event.latitude, event.longitude]}
                                    options={{
                                        iconLayout: 'default#image',
                                        iconImageHref: event.imageLink
                                            ? `https://mepointserver.ru${event.imageLink}`
                                            : userAvatar,
                                        iconImageSize: [50, 50],
                                        iconImageOffset: [-25, -25],
                                    }}
                                    onClick={() =>
                                        handlePlacemarkClick(event.id)
                                    }
                                />
                            ))}
                        <Placemark
                            geometry={[userlatitude, userlongitude]}
                            options={{
                                iconLayout: 'default#image',
                                iconImageHref: userLocation,
                                iconImageSize: [30, 40],
                                iconImageOffset: [-15, -20],
                            }}
                        />
                    </Map>
                </YMaps>
            </div>
        </div>
    );
};

export default MapPage;
